"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerIframeProductWidget = void 0;
var workspaceUrls_1 = require("./workspaceUrls");
var VALID_WORKSPACE_DOMAIN = ".accessacloud.com";
function getIframe(widgetElement) {
    return widgetElement.querySelector(".content-frame");
}
function isValidUrl(locationUrl, defaultUrl) {
    var url = new URL(locationUrl);
    if (defaultUrl) {
        var defaultURL = new URL(defaultUrl);
        if (url.hostname !== defaultURL.hostname) {
            return false;
        }
        else {
            return true;
        }
    }
    else {
        // we can assume any access owned domains are safe
        if (url.hostname.endsWith(VALID_WORKSPACE_DOMAIN)) {
            return true;
        }
        else {
            return false;
        }
    }
}
function navigateIFrame(iframe, url, settings, instanceId) {
    var iframeUrl = new URL(url);
    var iframeOrigin = iframeUrl.origin;
    // we have two ways of waiting for the iframe to be loaded/ready
    // this is because the old way does not work with react 18
    // and is a flawed approach for detecting if the react app is ready
    // new way
    // listen for pidgetready message the iframe will send
    // when the react app is ready to accept the pidgetload message
    var pidgetReadyMessage = function (event) {
        if (event.origin !== iframeOrigin) {
            return;
        }
        var message = JSON.parse(event.data);
        if (message.type === "pidgetready") {
            if (iframe.contentWindow) {
                iframe.contentWindow.postMessage({
                    type: "pidgetload",
                    widget: {
                        instanceId: instanceId,
                        settings: __assign(__assign({}, settings), { identityUrl: (0, workspaceUrls_1.mapWorkspaceToIdentity)(window.location.origin), workspaceUrl: window.location.origin })
                    }
                }, iframeOrigin);
            }
            window.removeEventListener("message", pidgetReadyMessage);
        }
    };
    window.addEventListener("message", pidgetReadyMessage);
    // old way - to be removed in a major release as a breaking change
    // send the pidgetload message as soon as the iframe is loaded
    // this is flawed and can mean a message is sent
    // before a react 18 app is ready
    iframe.addEventListener("load", function loadIframe() {
        if (iframe.contentWindow) {
            iframe.contentWindow.postMessage({
                type: "pidgetload",
                widget: {
                    instanceId: instanceId,
                    settings: __assign(__assign({}, settings), { identityUrl: (0, workspaceUrls_1.mapWorkspaceToIdentity)(window.location.origin), workspaceUrl: window.location.origin })
                }
            }, iframeOrigin);
        }
        iframe.removeEventListener("load", loadIframe);
    });
    iframe.src = url;
}
function navigate(iframe, url, defaultUrl, settings, instanceId) {
    if (isValidUrl(url, defaultUrl)) {
        navigateIFrame(iframe, url, settings, instanceId);
    }
    else {
        navigateIFrame(iframe, defaultUrl, settings, instanceId);
    }
}
function loadIframe(iframe, load, widget) {
    load({
        settings: widget.settings,
        instanceId: widget.instanceId,
        getAccessToken: function () { return widget.getAccessToken(); }
    })
        .then(function (loadProps) {
        if (loadProps.url && loadProps.defaultUrl) {
            navigate(iframe, loadProps.url, loadProps.defaultUrl, widget.settings, widget.instanceId);
        }
        else {
            widget.logError("no url provided to load");
        }
    })
        .catch(function (error) {
        var message;
        if (error instanceof Error)
            message = error.message;
        else
            message = String(error);
        widget.logError(message);
    });
}
function registerIframeProductWidget(_a) {
    var load = _a.load, onShow = _a.onShow, onHide = _a.onHide, start = _a.start;
    WidgetFramework.WidgetManager.registerProductWidget(function (widget) {
        var iframe = getIframe(widget.element);
        var allowCloseWithoutPrompt = true;
        if (iframe) {
            widget.configureFrame(iframe);
            // when registered naviagte to the correct url
            if (widget.locationUri) {
                // we have a saved deep link so just navigate
                if (start) {
                    start({
                        settings: widget.settings,
                        instanceId: widget.instanceId,
                        getAccessToken: function () { return widget.getAccessToken(); }
                    })
                        .then(function (startResponse) {
                        if (startResponse) {
                            if (startResponse.success) {
                                navigate(iframe, widget.locationUri, widget.settings.defaultUrl, widget.settings, widget.instanceId);
                            }
                            else {
                                widget.logError(startResponse.message);
                            }
                        }
                    })
                        .catch(function (error) {
                        var message;
                        if (error instanceof Error)
                            message = error.message;
                        else
                            message = String(error);
                        widget.logError(message);
                    });
                }
                else {
                    navigate(iframe, widget.locationUri, widget.settings.defaultUrl, widget.settings, widget.instanceId);
                }
            }
            else {
                // otherwise this is a first load so we need the app
                // to tell use the correct url to navigate to
                if (start) {
                    start({
                        settings: widget.settings,
                        instanceId: widget.instanceId,
                        getAccessToken: function () { return widget.getAccessToken(); }
                    })
                        .then(function (startResponse) {
                        if (startResponse) {
                            if (startResponse.success) {
                                loadIframe(iframe, load, widget);
                            }
                            else {
                                widget.logError(startResponse.message);
                            }
                        }
                    })
                        .catch(function (error) {
                        var message;
                        if (error instanceof Error)
                            message = error.message;
                        else
                            message = String(error);
                        widget.logError(message);
                    });
                }
                else {
                    loadIframe(iframe, load, widget);
                }
            }
            widget.onFrameMessage = function (message) {
                if (!message)
                    return;
                switch (message.type) {
                    case "LocationChanged":
                        widget.setLocation(message.url, message.title);
                        break;
                    case "RequestReauthentication":
                        widget.requestReauthentication(message.url);
                        break;
                    case "ShowLoading":
                        widget.showLoading();
                        break;
                    case "HideLoading":
                        widget.hideLoading();
                        break;
                    case "SetPromptBeforeClose":
                        allowCloseWithoutPrompt = message.allowCloseWithoutPrompt;
                        break;
                    default:
                        break;
                }
            };
            widget.onBeforeRemove = function () {
                return allowCloseWithoutPrompt;
            };
            widget.onLocationChanged = function (url) {
                navigate(iframe, url, widget.settings.defaultUrl, widget.settings, widget.instanceId);
            };
            if (onHide) {
                widget.onDashboardHidden = onHide;
            }
            if (onShow) {
                widget.onDashboardShown = onShow;
            }
        }
        else {
            widget.logError("no iframe found");
        }
    });
}
exports.registerIframeProductWidget = registerIframeProductWidget;
